import { useTranslation } from '@cobliteam/i18n';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';
import { cn } from '@cobliteam/ui/utils';

type AIBetaFlagVariant = 'default' | 'light';

interface AIBetaFlagProps {
  variant?: AIBetaFlagVariant;
  className?: string;
}

const AIBetaFlag = ({ variant = 'default', className }: AIBetaFlagProps) => {
  const { t } = useTranslation('ai');

  return (
    <Tooltip
      content={
        <div className='flex w-[300px] flex-col gap-2'>
          <div className='flex items-start gap-1.5'>
            <Icon name='info' className='mt-0.5 h-4 w-4 flex-shrink-0 text-gray-10' />
            <Typography variant='description-title'>{t('beta_flag.tooltip_title')}</Typography>
          </div>
          <div className='flex flex-col gap-1'>
            <Typography variant='description-list-default'>{t('beta_flag.tooltip_description')}</Typography>
            <Typography variant='description-list-default' className='text-xs italic'>
              {t('beta_flag.tooltip_notice')}
            </Typography>
          </div>
        </div>
      }
      align='start'
      position='bottom'
      className='border-none bg-white p-3 shadow-lg'
    >
      <button
        type='button'
        aria-label={t('beta_flag.tooltip_title')}
        className={cn(
          'cursor-pointer rounded px-1.5 py-0.5 font-semibold text-[10px] uppercase leading-none outline-none focus-visible:ring-2 focus-visible:ring-offset-1',
          variant === 'light' ? 'bg-white/20 text-white' : 'bg-[#FFA931] text-black',
          className
        )}
      >
        Beta
      </button>
    </Tooltip>
  );
};

export default AIBetaFlag;
